import Vue from 'vue';
import VueRouter from 'vue-router';
import {INFO} from '@/util/const';
import store from '@/store/index';

const theme = process.env.VUE_APP_THEME;
// const isDev = process.env.NODE_ENV === 'development'
let routes = require(`./modules/${theme}.js`).default

Vue.use(VueRouter);

// if(isDev){
// }

const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: `/${theme}/home`,
    },
    routes
  ]
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  const index = to.query.navIndex;
  if (index) {
    store.state.tabIndex = Number(index);
  }
  document.title = INFO.title;
  next();
});

export default router;
